import React, {
  ReactElement, useEffect, useLayoutEffect, useState,
} from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router';
import { getTitle, NotFoundPage, waitForElement } from 'slovlex-idsk-react-components';
import routes from './routes';
import handleAbsoluteUrlRedirects from './absoluteUrlHandler';
import {
  Layout,
  NavrhAktuEuDetailPage,
  NavrhAktuEuListPage,
  PravoEuDetailPage,
  VyhladavaniePravoEuPage,
} from '../page';
import { useSecurityContext } from '../context/SecurityContext';

const PravoEuRouter = (): ReactElement => {
  const location = useLocation();
  const navigate = useNavigate();
  const [parentIsSettingRoute, setParentIsSettingRoute] = useState(true);
  const [anchorIsSettingRoute, setAnchorIsSettingRoute] = useState(true);
  const { setAccessToken, setOrganizationId } = useSecurityContext();

  const onMessage = (event): void => {
    const message = event?.data;
    if (message) {
      if (message && message.type && message.type === 'parent-to-iframe-internal-route') {
        setParentIsSettingRoute(true);
        navigate(message.route, { replace: true });
      } else if (typeof message === 'string' && message.includes('accessToken=')) {
        setAccessToken?.(message.substring('accessToken='.length));
      } else if (typeof message === 'string' && message.includes('organizationId=')) {
        setOrganizationId?.(message.substring('organizationId='.length));
      }
    }
  };

  useEffect(() => {
    window.addEventListener('message', onMessage);
    window.addEventListener('click', () => {
      window.parent.postMessage({ type: 'iframe-to-parent-clicked' }, '*');
    });
    window.parent.postMessage({ type: 'iframe-to-parent-initialized' }, '*');
    handleAbsoluteUrlRedirects();
    if (window.self === window.top) {
      window.location.replace(`${process.env.REACT_APP_PORTAL_MAIN_URL}/pravo-eu`
        + `${location.pathname ? location.pathname : ''}`
        + `${location.search ? location.search : ''}${location.hash ? location.hash : ''}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useLayoutEffect(() => {
    if (document.referrer && document.referrer !== document.location.href
      && location.pathname !== routes.loading.to
      && parentIsSettingRoute && anchorIsSettingRoute) {
      notifyParent();
      setAnchorIsSettingRoute(false);
    }

    if (parentIsSettingRoute && anchorIsSettingRoute) {
      setParentIsSettingRoute(false);
      return;
    }
    notifyParent();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, location.hash, location.search, location.state]);

  const notifyParent = (): void => {
    waitForElement('#app > *')
      .then(() => {
        window.parent.postMessage({
          type: 'iframe-to-parent-internal-route',
          route: `/pravo-eu${location.pathname ? location.pathname : ''
          }${location.search ? location.search : ''
          }${location.hash ? location.hash : ''}`,
          title: getTitle(),
        }, '*');
      });
  };

  return (
    <Routes>
      <Route path={routes.pravoEu.list.to} element={<VyhladavaniePravoEuPage />} />
      <Route path={routes.pravoEu.detail.to} element={<PravoEuDetailPage />} />
      <Route path={routes.navrhyAktovEu.list.to} element={<NavrhAktuEuListPage />} />
      <Route path={routes.navrhyAktovEu.detail.to} element={<NavrhAktuEuDetailPage />} />
      <Route path={routes.loading.to} element={null} />
      <Route
        path="*"
        element={(
          <Layout>
            <NotFoundPage />
          </Layout>
        )}
      />
    </Routes>
  );
};

export default PravoEuRouter;
